/* Copyright 2021-2022 VMware, Inc. All rights reserved. VMware Confidential */

import { Directive, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { FormControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { CommerceLimits } from "@api/generated/vcdr/model/commerceLimits";

/**
 * Validate the subscription capacity value.
 */
// @formatter:off
@Directive({
    selector: "[validateCapacity][ngModel]",
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CapacityValidatorDirective),
        multi: true
    }]
})
// @formatter:on
export class CapacityValidatorDirective implements Validator {
    @Input() validateCapacity: CommerceLimits;
    @Output() invalidOutput = new EventEmitter<boolean>();

    validate(c: FormControl): ValidationErrors | null {
        const error: ValidationErrors = {
            validateMinMax: {
                valid: false
            }
        };

        this.invalidOutput.emit(false);

        // Ensure value only contains digits.
        if (c?.value === null || c?.value === undefined || !/^\d+$/.test(c.value)) {
            this.invalidOutput.emit(true);
            return error;
        }

        // Parse value as integer.
        const value: number = parseInt(c?.value, 10);
        if (isNaN(value)) {
            this.invalidOutput.emit(true);
            return error;
        }

        // Check whether value is within min and max range.
        const min: number = this.validateCapacity.subscription_min_quantity;
        const max: number = this.validateCapacity.subscription_max_quantity;
        if (value < min || (max && value > max)) {
            this.invalidOutput.emit(true);
            return error;
        }

        // Valid value.
        return null;
    }
}
